import request from '@/api-v2/request';
import type { RiskReportResponseDTO } from './types/custom-reports';
import type { FileSignedUrlDTO } from '@/types/dto/FileSignedUrlDTO';

/**
 * Retrieve the list of risk reports available within the last 30 days
 */
export const getRiskReports = (signal: AbortSignal): Promise<RiskReportResponseDTO[]> =>
  request({
    url: `/teams/risk-reports`,
    method: 'GET',
    signal,
  }).then((o) => o.data);

/**
 * Get the cloudfront signed url of the risk report for downloading
 * @param key - the s3 key (path) of the risk report
 */
export const getRiskReportUrl = (key: string): Promise<FileSignedUrlDTO> =>
  request({
    url: `/teams/risk-reports/url`,
    method: 'GET',
    params: { key },
  }).then((o) => o.data);
